export default function Divider({ className = 'mt-4 mb-10' }: { className?: string }) {
  return <div className={`w-full relative bg-gray-200 pt-[0.5px] ${className}`} />
}
